import React from "react";
import Signup from "./../../components/Signup";
import "./styles.scss";

const Registration = () => {
  return <Signup />;
};

export default Registration;
